import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import { View, Text, ActivityIndicator  } from 'react-native';
import Table from './Table';
import CustomComponent from 'root/libs/exaforte/react/CustomComponent';
import { CustomCheckBox } from 'root/libs/exaforte/react/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TouchableArea from 'root/libs/exaforte/react/TouchableArea';
import { faUndo } from '@fortawesome/pro-regular-svg-icons';
import { BlockView, BlockViewTitle, Button } from 'root/globals/Elements';
import Pagination from 'root/globals/Pagination';
import CustomFilter from 'root/globals/views/CustomFilter';
import { withStyles } from '@material-ui/core/styles';
import { FieldSet } from 'root/globals/Form';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { ContentDialog } from 'root/globals/Dialog';
import ExportDialog from 'root/globals/dialogs/ExportDialog';
import ImportDialog from 'root/globals/dialogs/ImportDialog';
import SelectionDialog from 'root/globals/dialogs/SelectionDialog';
import DeleteDialog from 'root/globals/dialogs/DeleteDialog';
import Menu from 'root/globals/views/Menu';
import {
    faTrash,
    faEdit,
    faEye,
} from '@fortawesome/pro-regular-svg-icons';
import { withRouter } from 'react-router';

const FieldSetCheckbox  =   withStyles({root: {
                                width: 'auto',
                            }})(FieldSet);


import defaults from 'root/globals/Defaults.less';
import custom_overview from './CustomOverview.less';

const styles = {...defaults, ...custom_overview};

export class OverviewTable extends React.Component {
    render() {
        let classnames = { table: [styles['table'], styles['table-' + this.props.breakpoint + '-responsive'], (this.props.onRowClick ? styles['clickable-table'] : ''), 'w-100'].join(' '), body: styles['body'], header: styles['header'], th: [styles['th'], styles['f-1-7-5'], 'd-flex align-items-center py-3 px-4', styles['background-color-white-gray'], styles['custom-table-head-td']].join(' '), tr: [styles['tr'], 'd-block d-' + this.props.breakpoint + '-flex'].join(' '), td: [styles['td'], styles['f-1-2-5'], styles['text-color-light-black'], 'align-items-center py-3 px-4', styles['custom-table-td'], 'd-block d-' + this.props.breakpoint + '-flex'].join(' '), selected: [styles['selected']].join(' ') };
        
        if(!_.is_empty(this.props.classNames))
            for(let i in this.props.classNames)
                if(!classnames[i])
                    classnames[i] = this.props.classNames[i];
                else
                    classnames[i] += ' ' + this.props.classNames[i];

        return (
            <Table 
                {...this.props}
                classNames={classnames}
                override_classnames={true}
             />
        );
    }
}

export default class CustomOverview extends CustomComponent {
    constructor(props)
    {
        super(props);
        
        this.state = {show_filter: true};
    }
    
    _toggleFilter() {
        this.setState({show_filter: !this.state.show_filter});
    }
    
    _handlePagination(page) {
        this.props.loadData(page);
    }
    
    render(){
        let filters_applied = (this.props.controller.config.filter ? _.size(this.props.controller.config.filter.get_filter()) : 0);

        return <>
            {this.props.controller.component.state.show_import_dialog && this.props.component && <ImportDialog component={this.props.component} closeCallback={this.props.toggleImportDialog} controller={this.props.controller} loadData={this.props.loadData} />}
            {this.props.controller.component.state.show_export_dialog && this.props.component && <ExportDialog component={this.props.component} closeCallback={this.props.toggleExportDialog} controller={this.props.controller} filter_model_class={this.props.filter_model_class} />}
            {this.props.controller.component.state.show_selection_dialog && this.props.component && <SelectionDialog component={this.props.component} closeCallback={this.props.toggleSelectionDialog} controller={this.props.controller} />}
            {this.props.controller.component.state.show_delete_dialog && this.props.component && <DeleteDialog title={'Let op!'} confirmCallback={() => {}} content={['Weet je zeker dat je deze selectie wilt verwijderen?']} component={this.props.component} closeCallback={this.props.toggleDeleteDialog} controller={this.props.controller} />}
            <BlockView className={[...['d-flex flex-column flex-' + this.props.breakpoint + '-row', styles['nopadding']], ...this.props.className || []]}>
                <View className={[(!this.props.fullscreen ? 'p-4 ' : '') + 'col-' + this.props.breakpoint + '-' + (this.props.controller.config.filter && !this.props.hideFilter ? 9 : 12) + ' order-12 order-' + this.props.breakpoint + '-1' + (this.state.show_filter ? '' : ' col-' + this.props.breakpoint + '-' + (this.props.controller.config.filter && !this.props.hideFilter ? '11' : '12'))]}>
                    {(this.props.title || this.props.actions) && <View className={['d-flex justify-content-between align-items-center ' + (this.props.description ? 'pb-2' : 'pb-4')]}>
                        <View className={['align-items-center d-flex']} style={{minHeight: 37}}>
                            <BlockViewTitle className={['mr-2']}>{this.props.title}</BlockViewTitle>
                            {(!_.is_empty(this.props.controller.component.state.amount) && !this.props.controller.component.state.fetching) && <Text className={[styles['services-header-number'], styles['color-light-grey'], styles['text-bold']]}>({_.money_format(this.props.controller.component.state.amount, {minimumFractionDigits: 0, style: 'decimal'})})</Text>}
                            {(this.props.controller.config.filter && filters_applied > 0) && <>
                                <Text className={[styles['services-header-filter'], styles['color-grey'], styles['f-1-5'], styles['text-light'], 'd-none d-' + this.props.breakpoint + '-block mr-2 ml-' + this.props.breakpoint + '-5']}>{filters_applied} filter{_.plural({amount: filters_applied, plural: 's'})} toegepast</Text>
                                <Button secondary={true} onPress={this.props.controller.config.filter.reset} className={['flex-row d-none d-' + this.props.breakpoint + '-flex']}>
                                    <Text className={[styles['mr-1']]}>Reset filter</Text>
                                    <FontAwesomeIcon icon={faUndo} />
                                </Button>
                            </>}
                        </View>
                        {this.props.actions && this.props.actions}
                    </View>}
                    {this.props.description && <Text className={['pb-2', styles['text-light']]}>{this.props.description}</Text>}
                    <View className={[(!this.props.fullscreen ? '' : 'row')]}>
                        {this.props.children && React.cloneElement(this.props.children, _.filterSupportedProps(this.props, { classNames: true, formatData: true, getDataField: true, formatHeader: true, onRowClick: true, controller: true, elementResponseElement: true, selectedIds: true, cellClassNamesCallback: true, rowClassNamesCallback: true, breakpoint: true, renderSubElement: true, data: true, columns: true }))}
                    </View>
                    {(this.props.handleSelectAll || (!_.is_empty(this.props.controller.component.state.page) && !_.is_empty(this.props.controller.component.state.amount) && !_.is_empty(this.props.controller.component.state.limit))) &&
                        <View className={['row mt-2 pl-2 pr-3 pr-' + this.props.breakpoint + '-4 justify-content-center justify-content-' + this.props.breakpoint + '-between d-flex flex-row']}>
                            {!this.props.controller.component.state.fetching && this.props.handleSelectAll && this.props.controller.component.state.amount > 0 ? <View className={['d-none d-' + this.props.breakpoint + '-flex flex-row align-items-center']}>
                                <FormControlLabel
                                  value="top"
                                  control={<CustomCheckBox onChangeText={this.props.handleSelectAll} wrapper={FieldSetCheckbox} value={(_.min([this.props.controller.component.state.limit, this.props.controller.component.state.amount]) == _.size(this.props.controller.component.state.selected_ids) ? 't' : 'f')} />}
                                  label={(_.min([this.props.controller.component.state.limit, this.props.controller.component.state.amount]) == _.size(this.props.controller.component.state.selected_ids) ? 'de' : '') + 'selecteer alles'}
                                />
                            </View> : <View />}
                            {(!_.is_empty(this.props.controller.component.state.page) && !_.is_empty(this.props.controller.component.state.amount) && !_.is_empty(this.props.controller.component.state.limit)) && 
                                <View className={['d-flex justify-content-center justify-content-' + this.props.breakpoint + '-end align-items-center']}>
                                    <Pagination 
                                        currentPage={this.props.controller.component.state.page}
                                        pageLimit={this.props.controller.component.state.limit}
                                        totalAmount={this.props.controller.component.state.amount}
                                        onPageSelect={this._handlePagination}
                                        selectPageAmount={this.props.selectPageAmount}
                                    />
                                </View>
                            }
                        </View>
                    }
                </View>
                {(this.props.controller.config.filter && !this.props.hideFilter) && <CustomFilter controller={this.props.controller} toggleFilter={this._toggleFilter} loadData={this.props.loadData} show={this.state.show_filter} breakpoint={this.props.breakpoint} />}
            </BlockView>
        </>
    }
}
CustomOverview.defaultProps = {
    children: <OverviewTable />,
    breakpoint: 'md'
}

export const EditMenu = withRouter(class EditMenu extends React.Component {
    constructor(props) {
        super(props);
        
        this.onRemove   = this.onRemove.bind(this);
        this.decline    = this.decline.bind(this);
        this.confirm    = this.confirm.bind(this);
        this._onView    = this._onView.bind(this);
        this._onEdit    = this._onEdit.bind(this);
        this.state      = {showConfirm: false, confirmed: false};
        this.paths      = _.merge({view: '/view/', form: '/form/'}, this.props.paths || {});
    }

    decline() {
        this.setState({showConfirm: false});
    }
    
    confirm(e) {
        this.setState({showConfirm: false, confirmed: true}, () => {
            this.props.onRemove(this.props.id, this.props.component_id);
        });
    }
    
    onRemove(e) {
        this.setState({showConfirm: true, confirmed: false});
    }
    
    _onView() {
        if(this.props.onView && _.isFunction(this.props.onView))
            this.props.onView(this.props.id, this.paths.view);
        else
            this.props.history.push(this.paths.view + this.props.id);
    }
    
    _onEdit() {
        if(this.props.onEdit && _.isFunction(this.props.onEdit))
            this.props.onEdit(this.props.id, this.paths.form);
        else
            this.props.history.push(this.paths.form + this.props.id);
    }
    
    render() {
        let items = [];
        
        if(this.props.actions.view)
            items.push({icon: faEye, title: 'Bekijk', onPress: this._onView});
        
        if(this.props.actions.commit)
            items.push({icon: faEdit, title: 'Bewerk', onPress: this._onEdit});

        if(this.props.actions.remove && this.props.onRemove)
            items.push({icon: faTrash, title: 'Verwijder', onPress: this.onRemove});

		if(!_.is_empty(this.props.extraItems))
            _.map(this.props.extraItems, (item) => {
		        if(this.props.actions[item.action])
	                items.push(item)
            });

        return <>
            {this.state.showConfirm && <ContentDialog maxWidth={'sm'} title={this.props.confirmTitle || 'Let op!'}>
                <Text className={[styles['color-dark-grey'], styles['f-1-7-5'], styles['text-light']]}>{this.props.removeConfirmText}</Text>
                <View className={['flex-row d-flex justify-content-end mt-4 pt-4', styles['border-color-light-grey'], styles['bt-1']]}>
                    <Button secondary={true} onPress={this.decline}>Nee, toch maar niet</Button>
                    <Button onPress={this.confirm} className={['ml-2']}>Ja, doe maar</Button>
                </View>
            </ContentDialog>}
            {!_.is_empty(items) && <Menu id={this.props.id} items={items} />}
        </>
    }
});
EditMenu.defaultProps = {
    removeConfirmText: 'Weet je zeker dat je dit item wilt verwijderen?'
}